module.exports = __webpack_public_path__ + "img/michelle.3ac7e7bb.png";